// PDP page select size functionality start (17-09-2025) 


document.addEventListener('DOMContentLoaded', () => {
  // ✅ Inject all required styles (shake + error highlight)
  const style = document.createElement('style');
  style.textContent = `
    @keyframes earthquake {
      0%, to { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
      20%, 40%, 60%, 80% { transform: translateX(10px); }
    }
    .shake-effect {
      animation: earthquake 0.5s ease-in-out;
      animation-iteration-count: 2;
    }
    .variant-picker-error {
      background-color: #fff7f8;
      padding: 15px 15px;
      border: 1px solid #f7e4e6;
      margin-bottom: 10px;
    }
    .data-variant-picker.variant-picker-error:before {
        content: 'Please Select Size...';
        margin-bottom: 10px;
        display: block;
        font-size: 15px;
        color: #d62a2a;
    }
  `;
  document.head.appendChild(style);

  // ✅ Add-to-cart logic (shared by both layouts)
  // {% comment %} function handleAddToCart(event, container) {
  //   const selectedRadio = container.querySelector('div.m-product-option--node input[type="radio"]:checked');
  //   const selectedRadioBand1 = container.querySelector('.band-cup-varient-title-1 div.m-product-option--node input[type="radio"]:checked');
  //   const selectedRadioBand2 = container.querySelector('.band-cup-varient-title-2 div.m-product-option--node input[type="radio"]:checked');
  //   const selectedRadioBandBan = container.querySelector('[data-option-name="BAND"] div.m-product-option--node input[type="radio"]:checked');
  //   const selectedRadioBandCup = container.querySelector('[data-option-name="CUP"] div.m-product-option--node input[type="radio"]:checked');
  //   const variantPicker = container.querySelector('[data-variant-picker]');
  //   console.warn("container", selectedRadio);
  //   if (!container.classList.contains("custom-quick-view") && (!selectedRadio)) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     console.warn("Not CUP dfds");
  //     if (variantPicker) {
  //       variantPicker.classList.add('shake-effect', 'variant-picker-error');
  //       setTimeout(() => {
  //         variantPicker.classList.remove('shake-effect');
  //       }, 1000);
  //     }
  //   }
  //   if (container.querySelector('[data-option-name="CUP"]') && (!selectedRadioBandBan || !selectedRadioBandCup)) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     console.warn("CUP fdsfsd");
  //     if (variantPicker) {
  //       variantPicker.classList.add('shake-effect', 'variant-picker-error');
  //       setTimeout(() => {
  //         variantPicker.classList.remove('shake-effect');
  //       }, 1000);
  //     }
  //   }
  // } {% endcomment %}

  function handleAddToCart(event, container) {
    const selectedRadio = container.querySelector('div.m-product-option--node input[type="radio"]:checked');
    const selectedRadioBandBan = container.querySelector('[data-option-name="BAND"] div.m-product-option--node input[type="radio"]:checked');
    const selectedRadioBandCup = container.querySelector('[data-option-name="CUP"] div.m-product-option--node input[type="radio"]:checked');
    const selectedRadioSize = container.querySelector('[data-option-name="Size"] div.m-product-option--node input[type="radio"]:checked');
    const variantPicker = container.querySelector('[data-variant-picker]');

    const isQuickView = container?.classList?.contains("custom-quick-view") ? true : false;
    const hasBAND = !!container.querySelector('[data-option-name="BAND"]');
    const hasCUP = !!container.querySelector('[data-option-name="CUP"]');
    const hasSize = !!container.querySelector('[data-option-name="Size"]');

    let isValid = true;

    // Log everything for clarity
    console.log("=== Add to Cart Validation ===");
    console.log("isQuickView:", isQuickView);
    console.log("selectedRadio:", selectedRadio);
    console.log("selectedRadioBandBan:", selectedRadioBandBan);
    console.log("selectedRadioBandCup:", selectedRadioBandCup);

    // 🚨 Validate for normal PDP (not quick view)
    if (isQuickView && !selectedRadio) {
      isValid = false;
      console.warn("❌ PDP: No variant selected");
    }

    // 🚨 Validate CUP/BAND if present
    if ((hasBAND && !selectedRadioBandBan) || (hasCUP && !selectedRadioBandCup)) {
      isValid = false;
      console.warn("❌ Quick View: CUP or BAND not selected");
    }
    // 🚨 Validate CUP/BAND if present
    if ((hasSize && !selectedRadioSize)) {
      isValid = false;
      console.warn("❌ PDP Simple: size not selected");
    }
    // ❌ If invalid, block Add to Cart and show error
    if (!isValid) {
      console.warn('dsss');
      event.preventDefault();
      event.stopPropagation();

      if (variantPicker) {
        variantPicker.classList.add('shake-effect', 'variant-picker-error');
        setTimeout(() => {
          variantPicker.classList.remove('shake-effect');
        }, 1000);
      }
    }
  }

  // ✅ Remove error style when user selects any radio input
  function bindRadioInputs(container) {
    const radios = container.querySelectorAll('div.m-product-option--node input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const variantPicker = container.querySelector('[data-variant-picker]');
        if (variantPicker) {
          variantPicker.classList.remove('variant-picker-error');
        }
      });
    });
  }

  // ✅ Global add-to-cart (for product page or first layout)
  function bindGlobalAddToCart() {
    const globalAddToCart = document.querySelector('.m-add-to-cart');
    // {% comment %} if (globalAddToCart && !globalAddToCart.hasAttribute('data-global-bound')) { {% endcomment %}
    if (globalAddToCart) {
      // {% comment %} globalAddToCart.setAttribute('data-global-bound', 'true'); {% endcomment %}
      globalAddToCart.addEventListener('click', (event) => {
        handleAddToCart(event, document);
      });
      bindRadioInputs(document);
    }
  }

  // {% comment %} function bindShopifyPaymentButton() {
  //   const shopifyPayBtn = document.querySelector('.shopify-payment-button__button');

  //   if (!shopifyPayBtn || shopifyPayBtn.hasAttribute('data-bound')) return;
  //   shopifyPayBtn.setAttribute('data-bound', 'true');

  //   // Wrap the button in a dummy clickable element
  //   const dummyBtn = document.createElement('button');
  //   dummyBtn.type = 'button';
  //   dummyBtn.textContent = shopifyPayBtn.textContent;
  //   dummyBtn.className = shopifyPayBtn.className + ' custom-buy-now-fake-btn';

  //   shopifyPayBtn.style.display = 'none'; // Hide real button
  //   shopifyPayBtn.parentElement.appendChild(dummyBtn); // Insert dummy button

  //   dummyBtn.addEventListener('click', function (event) {
  //     event.preventDefault();
  //     event.stopPropagation();

  //     const selectedRadio = document.querySelector('div.m-product-option--node input[type="radio"]:checked');
  //     const selectedRadioBandBan = document.querySelector('[data-option-name="BAND"] div.m-product-option--node input[type="radio"]:checked');
  //     const selectedRadioBandCup = document.querySelector('[data-option-name="CUP"] div.m-product-option--node input[type="radio"]:checked');
  //     const selectedRadioSize = document.querySelector('[data-option-name="Size"] div.m-product-option--node input[type="radio"]:checked');
  //     const variantPicker = document.querySelector('[data-variant-picker]');

  //     const hasBAND = !!document.querySelector('[data-option-name="BAND"]');
  //     const hasCUP = !!document.querySelector('[data-option-name="CUP"]');
  //     const hasSize = !!document.querySelector('[data-option-name="Size"]');
  //     let isValid = true;

  //     if ((hasBAND && !selectedRadioBandBan) || (hasCUP && !selectedRadioBandCup)) {
  //       isValid = false;
  //     }

  //     if (hasSize && !selectedRadioSize) {
  //       isValid = false;
  //     }

  //     if (!isValid) {
  //       if (variantPicker) {
  //         variantPicker.classList.add('shake-effect', 'variant-picker-error');
  //         setTimeout(() => {
  //           variantPicker.classList.remove('shake-effect');
  //         }, 1000);
  //       }
  //       return;
  //     }

  //     // ✅ Validation passed → trigger real Shopify button
  //     shopifyPayBtn.click();
  //   });

  //   bindRadioInputs(document);
  // } {% endcomment %}



  // ✅ Quick View behavior
  function setupQuickViewBehavior(quickView) {
    // Uncheck all radios
    const checkedRadios = quickView.querySelectorAll('input[type="radio"]:checked');
    checkedRadios.forEach(radio => (radio.checked = false));

    // Replace Add to Cart to avoid duplicate listeners
    const addToCartBtn = quickView.querySelector('.m-add-to-cart');
    if (addToCartBtn) {
      const newBtn = addToCartBtn.cloneNode(true);
      addToCartBtn.replaceWith(newBtn);
      newBtn.addEventListener('click', (event) => {
        handleAddToCart(event, quickView);
      });
    }

    const buyNowBtn = quickView.querySelector('shopify-buy-it-now-button .shopify-payment-button__button');
    if (buyNowBtn && !buyNowBtn.hasAttribute('data-custom-bound')) {
      buyNowBtn.setAttribute('data-custom-bound', 'true');

      // Create proxy button
      const proxyBtn = document.createElement('button');
      proxyBtn.type = 'button';
      proxyBtn.textContent = buyNowBtn.textContent;
      proxyBtn.className = buyNowBtn.className + ' custom-buy-now-proxy-btn';

      buyNowBtn.style.display = 'none';
      buyNowBtn.parentElement.appendChild(proxyBtn);

      proxyBtn.addEventListener('click', function(event) {
        handleAddToCart(event, quickView);
        if (event.defaultPrevented) {
          return;
        }
        buyNowBtn.click();
      });
    }


    bindRadioInputs(quickView);
  }

  // ✅ On Quick View button click
  function onQuickViewButtonClick() {
    const waitForQuickView = setInterval(() => {
      const quickView = document.querySelector('.custom-quick-view');
      if (quickView) {
        clearInterval(waitForQuickView);
        setupQuickViewBehavior(quickView);
      }
    }, 200);
    setTimeout(() => clearInterval(waitForQuickView), 5000); // fallback
  }

  // ✅ Bind all Quick View buttons
  function bindQuickViewButtons() {
    const quickBtns = document.querySelectorAll('.quick-view-button:not([data-bound])');
    quickBtns.forEach(btn => {
      btn.setAttribute('data-bound', 'true');
      btn.addEventListener('click', onQuickViewButtonClick);
    });
  }

  // ✅ Smart retry for both layouts
  function smartRetryBinding() {
    bindQuickViewButtons();
    bindGlobalAddToCart();
    // {% comment %} bindShopifyPaymentButton(); {% endcomment %}
  }

  // Initial
  smartRetryBinding();

  // ✅ Watch for DOM changes (dynamic loading)
  const observer = new MutationObserver(() => {
    smartRetryBinding();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});


// PDP page select size functionality end 